const map = {
	"./4-bilhoes-de-infinitos/slides/4 bilhoes de infinitos 1.jpg": 6060,
	"./4-bilhoes-de-infinitos/slides/4 bilhoes de infinitos 2.jpg": 4363,
	"./a-retirada-para-um-coracao-bruto/slides/A retirada para um coração bruto 1.jpg": 3098,
	"./a-retirada-para-um-coracao-bruto/slides/A retirada para um coração bruto 2.jpg": 5701,
	"./a-ultima-vez-que-ouvi-deus-chorar/slides/A ultima vez que ouvi Deus chorar 1.png": 7971,
	"./a-ultima-vez-que-ouvi-deus-chorar/slides/A ultima vez que ouvi Deus chorar 2.png": 1112,
	"./abducao/slides/Abdução 1.jpg": 2251,
	"./abducao/slides/Abdução 2.jpg": 5804,
	"./abducao/slides/Abdução 3.jpg": 3593,
	"./alma-bandida/slides/Alma Bandida 1.jpg": 5536,
	"./alma-bandida/slides/Alma Bandida 2.jpg": 9887,
	"./anderson/slides/Anderson 1.jpg": 423,
	"./anderson/slides/Anderson 2.jpg": 3928,
	"./anderson/slides/Anderson 3.jpg": 8757,
	"./anderson/slides/Anderson 4.png": 3114,
	"./canto-meu-alvara/slides/frame-1.png": 1226,
	"./canto-meu-alvara/slides/frame-2.png": 5889,
	"./canto-meu-alvara/slides/frame-3.png": 5944,
	"./canto-meu-alvara/slides/frame-4.png": 1111,
	"./canto-meu-alvara/slides/frame-5.png": 9774,
	"./joao-batista/slides/Joao Batista 1.jpg": 696,
	"./joao-batista/slides/Joao Batista 2.jpg": 1623,
	"./joao-batista/slides/Joao Batista 3.jpg": 458,
	"./joao-batista/slides/Joao Batista 4.jpg": 6921,
	"./morro-do-cemiterio/slides/Morro do Cemitério 1.jpg": 8669,
	"./morro-do-cemiterio/slides/Morro do Cemitério 2.jpg": 9714,
	"./morro-do-cemiterio/slides/Morro do Cemitério 3.jpg": 6095,
	"./morro-do-cemiterio/slides/Morro do Cemitério 4.jpg": 3364,
	"./paisagem-de-inverno/slides/slide-1.jpg": 1190,
	"./paisagem-de-inverno/slides/slide-2.jpg": 3329,
	"./paisagem-de-inverno/slides/slide-3.jpg": 3380,
	"./paisagem-de-inverno/slides/slide-4.jpg": 6111,
	"./paisagem-de-inverno/slides/slide-5.jpg": 9730,
	"./serrao/slides/Serrão 1.jpg": 817,
	"./serrao/slides/Serrão 2.jpg": 3046,
	"./serrao/slides/Serrão 3.jpg": 4099,
	"./simone/slides/simone1.png": 3477,
	"./simone/slides/simone2.png": 5646,
	"./simone/slides/simone3.png": 5143,
	"./simone/slides/simone4.png": 3000,
	"./simone/slides/simone5.png": 4129,
	"./simone/slides/simone6.png": 3050,
	"./soneca-e-jupa/slides/soneca e jupa 1.jpg": 4395,
	"./soneca-e-jupa/slides/soneca e jupa 2.jpg": 2412,
	"./soneca-e-jupa/slides/soneca e jupa 3.jpg": 3465,
	"./soneca-e-jupa/slides/soneca e jupa 4.jpg": 2570,
	"./teoria-sobre-um-planeta-estranho/slides/Teoria sobre um Planeta Estranho 1.jpg": 7603,
	"./teoria-sobre-um-planeta-estranho/slides/Teoria sobre um Planeta Estranho 2.jpg": 1540,
	"./trindade/slides/Trindade 1.jpg": 6951,
	"./trindade/slides/Trindade 2.jpg": 8552,
	"./trindade/slides/Trindade 3.jpg": 5717,
	"./trindade/slides/Trindade 4.jpg": 718
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9406;